import styled from 'styled-components'

export const Separator = styled.div`
  border: 1px dashed var(--gray200);
  margin: 24px 0px;
`
